const Theme = {
  colors: {
    body: "#383D42",
    primary: "#84C24A",
    dark: "#383D42",
    grey: "#eaeaea",
  },
  grid: {
    queries: {
      sm: "only screen and (min-width: 576px)",
      md: "only screen and (min-width: 768px)",
      lg: "only screen and (min-width: 992px)",
      xl: "only screen and (min-width: 1200px)",
      xxl: "only screen and (min-width: 1400px)",
    },
    breakpoints: {
      sm: "540px",
      md: "720px",
      lg: "960px",
      xl: "1140px",
      xxl: "1320px",
    },
    widths: {
      1: "8.33333333%",
      2: "16.66666667%",
      3: "25%",
      4: "33.33333333%",
      5: "41.66666667%",
      6: "50%",
      7: "58.33333333%",
      8: "66.66666667%",
      9: "75%",
      10: "83.33333333%",
      11: "91.66666667%",
      12: "100%",
    },
    gutter: "16px",
    sectionPadding: "32px",
  },
};

export default Theme;
